import React from "react";
import SplitAllocationModal from "./SplitAllocationModal";
import { getElementDamageValue } from "../utils/damageCombinations";

/**
 * Damage combination splits for area-data elements ("C2A-60;C3B-40").
 *
 * Same form as access methods, with two deliberate differences: codes come
 * from the Corrosion & Damage master and cannot be created inline, and there is
 * no side panel — nothing global hangs off a damage combination the way
 * productivity adjustments hang off a method.
 */
const DamageCombinationsModal = ({
  element,
  mode,
  targets,
  combinationOptions,
  getLevelLabel,
  onSave,
  onClose,
}) => (
  <SplitAllocationModal
    element={element}
    mode={mode}
    targets={targets}
    getLevelLabel={getLevelLabel}
    onSave={({ elementIds, value }) =>
      onSave({ elementIds, damageCombinations: value })
    }
    onClose={onClose}
    options={combinationOptions}
    onAddOption={null}
    getElementValue={getElementDamageValue}
    title="Damage Combinations"
    itemLabel="damage combination"
    itemLabelPlural="damage combinations"
    selectPlaceholder="Select damage combination..."
    summaryLabel="Current damage areas"
    describeIntro={
      mode === "parent"
        ? "Split each element's area across corrosion/damage combinations, then choose which elements it applies to. Percentages must total 100."
        : "Split this element's area across corrosion/damage combinations. Percentages must total 100."
    }
    footNote={
      <div className="mb-4 px-3 py-2 rounded bg-blue-50 border border-blue-200 text-sm text-blue-900">
        A single combination means the whole area sits in that class — the same
        as before. Use two or more when one element spans different exposure
        classes or damage levels, for example{" "}
        <span className="font-mono text-xs">C2A-60;C3B-40</span>.
      </div>
    }
  />
);

export default DamageCombinationsModal;
